import { c as _c } from "react/compiler-runtime";
import type { ComponentPropsWithoutRef, ReactNode } from "react";
import { cn } from "@/lib/utils";
export type HeaderTitleSize = "l" | "m";

/**
 * Title typography for app headers. `l` is the page title, nudged up
 * 1px: centred in the header, its baseline lands ~1.5px below the sidebar's
 * 16px title, so the shift puts both on one visual line. `m` is the sidebar /
 * pane title.
 */
export function headerTitleClassName(size: HeaderTitleSize) {
  return size === "l" ? "-translate-y-px type-page-title-l text-neutral-900 dark:text-white" : "type-page-title-m whitespace-nowrap text-neutral-900 dark:text-white";
}
interface HeaderTitleProps extends ComponentPropsWithoutRef<"h1"> {
  as?: "h1" | "h2" | "div" | "span";
  size?: HeaderTitleSize;
  children?: ReactNode;
}
export function HeaderTitle(t0) {
  const $ = _c(14);
  let children;
  let className;
  let rest;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      as: t1,
      size: t2,
      className,
      children,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = rest;
    $[4] = t1;
    $[5] = t2;
  } else {
    children = $[1];
    className = $[2];
    rest = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const Tag = t1 === undefined ? "h1" : t1;
  const size = t2 === undefined ? "l" : t2;
  let t3;
  if ($[6] !== className || $[7] !== size) {
    t3 = cn(headerTitleClassName(size), className);
    $[6] = className;
    $[7] = size;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== Tag || $[10] !== children || $[11] !== rest || $[12] !== t3) {
    t4 = <Tag className={t3} {...rest}>{children}</Tag>;
    $[9] = Tag;
    $[10] = children;
    $[11] = rest;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}